export default class TokenStorage {

  static storeAuthToken(authToken) {
    localStorage.setItem('auth_token', authToken);
  }

  static getAuthToken() {
    return localStorage.getItem('auth_token');
  }

  static destroyAuthToken() {
    localStorage.removeItem('auth_token');
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/token_storage.js